import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-label" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "menu-label" }

import { Menu, Document, Setting, User, House, Star } from '@element-plus/icons-vue'
  import * as AllIcons from '@element-plus/icons-vue'
  import { useRouter } from 'vue-router'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenuItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

  const router = useRouter()
  
  

  const getMenuHref = (path: string) => {
    if (!path) return 'javascript:void(0);'
    try {
      return router.resolve(path).href
    } catch (e) {
      return 'javascript:void(0);'
    }
  }

  const handleLinkClick = (event: MouseEvent) => {
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      event.stopPropagation()
      return
    }
    event.preventDefault()
  }
  
  // 图标映射函数
  const getIconComponent = (iconName: string) => {
    // 如果已经是组件，直接返回
    if (typeof iconName === 'object') {
      return iconName
    }
    
    // 图标名称映射
    const iconMap: Record<string, any> = {
      'fa-star': Star,
      'fa-home': House,
      'fa-user': User,
      'fa-cog': Setting,
      'fa-file': Document,
      'fa-menu': Menu,
      // 添加更多映射...
    }
    
    if (iconName in iconMap) {
      return iconMap[iconName]
    }

    const icons = AllIcons as Record<string, any>
    if (icons[iconName]) {
      return icons[iconName]
    }
    
    // 默认返回Menu图标
    return Menu
  }
  
return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_sidebar_menu_item = _resolveComponent("sidebar-menu-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (__props.item.children && __props.item.children.length > 0 && !__props.item.IsHide && !__props.item.IsButton)
    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: __props.item.path || __props.item.id
      }, {
        title: _withCtx(() => [
          (__props.item.meta?.icon || __props.item.iconCls)
            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(__props.item.meta?.icon || __props.item.iconCls))))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_1, _toDisplayString(__props.item.meta?.title || __props.item.name), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
            return (_openBlock(), _createBlock(_component_sidebar_menu_item, {
              key: child.id,
              item: child,
              "is-collapse": __props.isCollapse
            }, null, 8, ["item", "is-collapse"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["index"]))
    : (!__props.item.IsHide && !__props.item.IsButton && __props.item.path && __props.item.path !== '-')
      ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 1,
          index: __props.item.path
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              href: getMenuHref(__props.item.path),
              onClick: handleLinkClick,
              class: "menu-anchor"
            }, [
              (__props.item.meta?.icon || __props.item.iconCls)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(__props.item.meta?.icon || __props.item.iconCls))))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_3, _toDisplayString(__props.item.meta?.title || __props.item.name), 1)
            ], 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["index"]))
      : _createCommentVNode("", true)
}
}

})